import { get } from "lodash";
export const getOrderList = (state, patientId) =>
  get(state, `order.mapByPatient.${patientId}.orderList`, []);
export const getPaymentSourceList = (state, patientId) =>
  get(state, `order.mapByPatient.${patientId}.paymentSourceList`, []);
export const getKlarnaClientToken = (state, patientId) =>
  get(state, `order.mapByPatient.${patientId}.klarnaClientToken`, []);
export const getOrderSegmentList = (state, patientId) =>
  get(state, `order.mapByPatient.${patientId}.orderSegmentList`, []);
